(function () {
  angular.module('MktzapApp.Controllers')
    .controller('DashboardSettingsController', dashboard_settings);

  dashboard_settings.$inject = ['$rootScope', 'CompanyService', 'NotificationService', 'DashboardService'];

  function dashboard_settings ($rootScope, CompanyService, NotificationService, DashboardService) {
    var vmDashboard = this;

    $rootScope.getPageLabels('menu.config.dashSett');

    vmDashboard.reports = [];

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmDashboard.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorMetadata);
      });

    vmDashboard.allow = function (key) {
      CompanyService
        .saveMetadata(vmDashboard.metadata)
        .$promise
        .then(function (data) {
       		$rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.configUpdated);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.notActive);
        });
    };

    vmDashboard.saveDashboard = function (number) {
      CompanyService
        .saveMetadata({ id: $rootScope.user_data.company_id }, vmDashboard.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.paramsUpdated);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorUpdateParams);
        });
    }

    vmDashboard.getAllReports = function () {
      var result = document.getElementsByClassName('reports');
      vmDashboard.reports = result;
    }

    vmDashboard.getAllReports();
  }
})();
